import styled from "styled-components";
import { i18n } from "../translate/i18n";

import teste_carga from "../images/Teste-de-carga.jpeg";
import logistics_tablet from "../images/logistics-tablet.jpg";

export default function MainMenu() {
  return (
    <>
      <Title>{i18n.t("main_menu.titles.title1")}</Title>
      <Companies>
        <Box>
          <img src={teste_carga} alt="solução industrial" />
        </Box>
        <Box>
          <p>{i18n.t("main_menu.messages.message1")}</p>
        </Box>
      </Companies>
      <Title>{i18n.t("main_menu.titles.title2")}</Title>
      <Companies>
        <Box>
          <p>{i18n.t("main_menu.messages.message2")}</p>
        </Box>
        <Box>
          <img src={logistics_tablet} alt="solução industrial" />
        </Box>
      </Companies>
    </>
  );
}

const Companies = styled.div`
  display: flex;
  align-items: center;
  height: auto;
`;

const Title = styled.div`
  text-align: center;
  font-size: 16px;
  margin-bottom: 5px;
`;

const Box = styled.div`
  width: 100%;
  padding: 20px;

  p {
    margin-bottom: 15px;
  }

  div {
    width: 100%;
    //text-align: right;
  }

  a {
    font-size: 16px;
    color: #ffffff;
  }

  img {
    object-fit: contain;
    width: 100%;
    height: 500px;

  }
`;
